import { EMOTIONS_FACE } from '../../data/types';

export const BehaviorToFacial: { [key: string]: EMOTIONS_FACE } = {
  NEUTRAL: EMOTIONS_FACE.NEUTRAL,
  DISGUST: EMOTIONS_FACE.ANGRY,
  CONTEMPT: EMOTIONS_FACE.ANGRY,
  BELLIGERENCE: EMOTIONS_FACE.ANGRY,
  DOMINEERING: EMOTIONS_FACE.ANGRY,
  CRITICISM: EMOTIONS_FACE.ANGRY,
  ANGER: EMOTIONS_FACE.ANGRY,
  TENSION: EMOTIONS_FACE.FEAR,
  TENSE_HUMOR: EMOTIONS_FACE.HUMOR,
  DEFENSIVENESS: EMOTIONS_FACE.FEAR,
  WHINING: EMOTIONS_FACE.SAD,
  SADNESS: EMOTIONS_FACE.SAD,
  STONEWALLING: EMOTIONS_FACE.ANGRY,
  INTEREST: EMOTIONS_FACE.JOY,
  VALIDATION: EMOTIONS_FACE.AFFECTION,
  AFFECTION: EMOTIONS_FACE.AFFECTION,
  HUMOR: EMOTIONS_FACE.HUMOR,
  SURPRISE: EMOTIONS_FACE.NEUTRAL,
  JOY: EMOTIONS_FACE.JOY,
};
